var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showStub
        ? _c("div", [
            _vm._m(0),
            _c("div", { staticClass: "row justify-center" }, [
              _c(
                "a",
                {
                  staticClass: "col-xs-6 col-md-6 text-center",
                  attrs: { href: _vm.androidUrl, target: "_blank" }
                },
                [
                  _c("img", {
                    staticStyle: { "max-width": "150px" },
                    attrs: {
                      src: "/statics/google-play-badge.png",
                      alt: "Get it on Google Play"
                    }
                  })
                ]
              ),
              _c(
                "a",
                {
                  staticClass: "col-xs-6 col-md-6 text-center",
                  attrs: { href: _vm.iosUrl, target: "_blank" }
                },
                [
                  _c("img", {
                    staticStyle: { "max-width": "135px", "margin-top": "10px" },
                    attrs: {
                      src: "/statics/app-store-badge.svg",
                      alt: "Get it on App Store"
                    }
                  })
                ]
              )
            ])
          ])
        : _vm.isLocal
        ? _c(
            "bj-form",
            {
              ref: "form",
              attrs: { fields: _vm.fields, data: _vm.payload },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.submit($event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-12",
                  attrs: { slot: "start" },
                  slot: "start"
                },
                [
                  _c(
                    "h5",
                    { staticClass: "no-margin underline-title text-bold" },
                    [_vm._v("\n        Sign in to Showdigs\n      ")]
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "col-xs-5 col-md-6",
                  attrs: { slot: "end" },
                  slot: "end"
                },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      "no-caps": "",
                      rounded: "",
                      color: "primary",
                      label: "Sign in"
                    },
                    on: { click: _vm.submit }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "col-xs-7 col-md-6 text-right",
                  attrs: { slot: "end" },
                  slot: "end"
                },
                [
                  _c("q-btn", {
                    attrs: {
                      "no-caps": "",
                      to: { name: "auth.forgot-password" },
                      label: "Forgot Password?",
                      rounded: "",
                      flat: ""
                    }
                  })
                ],
                1
              )
            ]
          )
        : _c("div", { staticClass: "column items-center" }, [
            _vm._m(1),
            _c(
              "div",
              {
                staticClass: "col-12 q-mt-md",
                staticStyle: { "max-width": "360px", width: "100%" }
              },
              [
                _c("div", { attrs: { id: "google-signin-button" } }),
                _vm.isGoogleLoading
                  ? _c(
                      "div",
                      { staticClass: "text-center q-pa-md" },
                      [
                        _c("q-spinner", {
                          attrs: { color: "primary", size: "2em" }
                        }),
                        _c("div", { staticClass: "q-mt-sm" }, [
                          _vm._v(
                            "\n          Loading Google Sign-In...\n        "
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.googleError
                  ? _c(
                      "div",
                      { staticClass: "text-negative text-center q-pa-md" },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.googleError) + "\n      "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ]),
      _c("bj-inner-loading", {
        attrs: { visible: _vm.loading, label: "Signing in" }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h5", { staticClass: "no-margin text-bold text-center" }, [
        _vm._v("\n        Please use the Showdigs Agent app to log in\n      ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h5", { staticClass: "no-margin underline-title text-bold" }, [
        _vm._v("\n        Sign in to Showdigs\n      ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }